<template>
  <div id="contextMenu">
    <vue-context ref="menu">
      <template slot-scope="child">
        <template v-if="clickObject === nodeTypes.fact">
          <li>
            <a @click.prevent="addDimension($event.target.innerText, child.data)">
              <font-awesome-icon :icon="['fas', 'list']" />
              Add Dimension
            </a>
          </li>
          <li>
            <!--            <a @click.prevent="addMeasure($event.target.innerText, child.data)">-->
            <!--              <font-awesome-icon :icon="['fas', 'plus']"/>-->
            <!--              Add Measure-->
            <!--            </a>-->
            <a @click.prevent="addAttribute($event.target.innerText, child.data)">
              <font-awesome-icon :icon="['fas', 'plus']" />
              Add Attribute
            </a>
          </li>
          <li>
            <a @click.prevent="addLink($event.target.innerText, child.data)">
              <font-awesome-icon :icon="['fas', 'link']" />
              Add Link
            </a>
          </li>
          <hr class="mt-2 mb-2">
          <li>
            <a @click.prevent="editFact($event.target.innerText, child.data)">
              <font-awesome-icon :icon="['fas', 'pencil-alt']" />
              Edit Fact
            </a>
          </li>
          <li v-if="showAttributes">
            <a @click.prevent="modifyAttributesHelper(true)">
              <font-awesome-icon :icon="['fas', 'pencil-alt']" />
              Edit Attributes
            </a>
          </li>
          <hr class="mt-2 mb-2">
          <!--<li>
            <a @click.prevent="deleteMeasureHelper($event.target.innerText, child.data)">
              <font-awesome-icon :icon="['fas', 'trash']"/>
              Delete Measure...
            </a>
            <ul v-if="node.measures.length">
              <li v-for="measure of node.measures">
                <a @click="onDeleteMeasure(measure)">{{measure.name}}</a>
              </li>
            </ul>
          </li>-->
          <li>
            <a @click.prevent="deleteFactHelper($event.target.innerText, child.data)">
              <font-awesome-icon :icon="['fas', 'trash']" />
              Delete Fact
            </a>
          </li>
          <li>
            <a @click.prevent="deleteLinkHelper($event.target.innerText, child.data)">
              <font-awesome-icon :icon="['fas', 'trash']" />
              Delete Links
            </a>
            <!--<ul v-if="node.links.length">
              <li v-for="link of node.links">
                <a @click="onDeleteLink(link)">{{ getDimensionName(link) }}</a>
              </li>
            </ul>-->
          </li>
          <li v-if="showAttributes">
            <a @click.prevent="modifyAttributesHelper()">
              <font-awesome-icon :icon="['fas', 'trash']" />
              Delete Attributes
            </a>
          </li>
        </template>
        <template v-if="clickObject === nodeTypes.dimension">
          <li v-if="child.data && !child.data.isCopy">
            <a @click.prevent="editDimension($event.target.innerText, child.data)">
              <font-awesome-icon :icon="['fas', 'pencil-alt']" />
              Edit Dimension
            </a>
          </li>
          <li>
            <a @click.prevent="addAttribute($event.target.innerText, child.data)">
              <font-awesome-icon :icon="['fas', 'plus']" />
              Add Attribute
            </a>
          </li>
          <li v-if="child.data && !child.data.isCopy">
            <a @click.prevent="addLink($event.target.innerText, child.data)">
              <font-awesome-icon :icon="['fas', 'link']" />
              Add Link
            </a>
          </li>
          <hr>
          <li>
            <a @click.prevent="deleteDimensionHelper($event.target.innerText, child.data)">
              <font-awesome-icon :icon="['fas', 'trash']" />
              Delete Dimension
            </a>
          </li>
          <li>
            <a @click.prevent="deleteLinkHelper($event.target.innerText, child.data)">
              <font-awesome-icon :icon="['fas', 'trash']" />
              Delete Links
            </a>
          </li>
          <li v-if="showAttributes">
            <a @click.prevent="modifyAttributesHelper()">
              <font-awesome-icon :icon="['fas', 'trash']" />
              Delete Attributes
            </a>
          </li>
        </template>
        <template v-if="clickObject === nodeTypes.attribute">
          <li>
            <a @click.prevent="editAttribute($event.target.innerText, child.data)">
              <font-awesome-icon :icon="['fas', 'pencil-alt']" />
              Edit Attribute
            </a>
          </li>
          <li>
            <a @click.prevent="deleteAttributeHelper($event.target.innerText, child.data)">
              <font-awesome-icon :icon="['fas', 'trash']" />
              Delete Attribute
            </a>
          </li>
        </template>
        <template v-if="clickObject === 'svg'">
          <li>
            <a @click="resetView()">
              <font-awesome-icon :icon="['fas', 'undo-alt']" />
              Reset View
            </a>
          </li>
          <li>
            <a @click.prevent="showFactModal()">
              <font-awesome-icon :icon="['fas', 'table']" />
              Add Fact Table
            </a>
          </li>
          <li>
            <a @click.prevent="showDimensionModal()">
              <font-awesome-icon :icon="['fas', 'list']" />
              Add Dimension
            </a>
          </li>
        </template>
      </template>
    </vue-context>

    <RemoveItemsModal :remove-modal="removeModal" />
  </div>
</template>

<script>

import {createNamespacedHelpers} from 'vuex';
import ContentSpinner from '../../core/components/ContentSpinner';
import VueContext from 'vue-context';
import {setConfirmModal, toggleRemoveItemsModal} from '../../store/modules/sun-model/actions';
import RemoveItemsModal from './RemoveItemsModal';


const {mapState, mapActions} = createNamespacedHelpers('sunModel');
export default {
  name: 'AttributesModal',
  components: {
    ContentSpinner, VueContext, RemoveItemsModal,
  },
  props: {
    clickObject: {
      required: true,
      type: String,
    },
    node: {
      type: Object,
    },
    showAttributes: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      confirmModalData: {
        show: false,
        title: null,
        text: null,
        yesText: 'Yes',
        okVariant: 'danger',
        noText: 'No',
        callback: null,
      },
      removeModal: {
        show: false,
        title: null,
        items: [],
        fields: [],
      },
      isAttrEdit: false,
    };
  },
  watch: {
    originalData() {
      if (this.isAttrEdit) {
        this.modifyAttributesHelper(true);
      }
    },
  },
  computed: {
    ...mapState({
      originalData: state => state.sunModel.originalData,
      data: state => state.sunModel.data,
      nodeTypes: state => state.sunModel.nodeTypes,
    }),
  },
  methods: {
    ...mapActions(['showDimensionModal', 'setFactLink', 'showMeasuresModal', 'showLinkFactModal',
      'showAttributesModal', 'showFactModal', 'showDimensionModal', 'deleteAttribute', 'setConfirmModal',
      'deleteDimension', 'deleteFact', 'setRemoveItemsModal', 'deleteMeasure', 'deleteLink', 'toggleRemoveItemsModal']),
    getDimensionName(link) {
      return link.alias ? link.alias : this.originalData.dimensions.find(dim => dim.entityId === link.toEntityId).entityDisplayName;
    },
    addDimension(label, d) {
      this.setFactLink(d.entityId);
      this.showDimensionModal();
    },
    addMeasure(label, d) {
      this.showMeasuresModal({fact: d.name});
    },
    editFact(label, item) {
      this.showFactModal(item);
    },
    editDimension(label, item) {
      this.showDimensionModal(item);
    },
    editAttribute(label, item) {
      this.showAttributesModal({entityId: item.entityId, data: item});
    },
    addLink(label, d) {
      const data = {
        fromEntityId: '',
        toEntityId: '',
      };
      if (d.entityType === 'fact') {
        data.fromEntityId = d.entityId;
      } else {
        data.toEntityId = d.entityId;
      }
      this.showLinkFactModal(data);
    },
    addAttribute(label, d) {
      const entityId = d.isCopy ? d.mainDimId : d.entityId;
      const entityType = d.isCopy ? 'dimension' : d.type;
      this.showAttributesModal({entityId: entityId, entityType: entityType, data: null});
    },
    // onDeleteMeasure(measure) {
    //   console.log('Click ', measure);
    // },
    async onDeleteLink(link) {
      this.toggleRemoveItemsModal();
      const res = await this.deleteLink(link.linkId);
      if (res.success) {
        this.$toasted.success('Link deleted successfully', {
          duration: TOASTER_DURATION,
        });
      } else {
        this.$toasted.error(res.body.ErrorMessage, {
          duration: TOASTER_DURATION,
        });
      }
      return res;
    },
    async onDeleteAttribute(item) {
      this.toggleRemoveItemsModal();
      const res = await this.deleteAttribute(item.isCopy ? item.mainAttributeId : item.attributeId);
      if (res.success) {
        this.$toasted.success('Attribute deleted successfully', {
          duration: TOASTER_DURATION,
        });
      } else {
        this.$toasted.error(res.body.ErrorMessage, {
          duration: TOASTER_DURATION,
        });
      }
      return res;
    },
    deleteAttributeHelper(label, d) {
      const vm = this;
      this.setConfirmModal({
        ...vm.confirmModalData,
        ...{
          show: true,
          title: 'Delete Attribute',
          text: `Are you sure you want to delete ${d.attributeDisplayName}?`,
          callback: async () => {
            await vm.onDeleteAttribute(d);
          },
        },
      });
    },
    deleteDimensionHelper(label, d) {
      const vm = this;
      let deleteConfirmModalText = [];

      const dimensions = this.data.dimensions.filter(dim => d.entityId === dim.mainDimId);
      let listOfDimensions;
      if (dimensions.length > 0) {
        listOfDimensions = dimensions.map(dim => dim.entityDisplayName).join(', ');
        deleteConfirmModalText.push(`Dimensions(s): ${listOfDimensions}`);
      }

      const attributes = this.originalData.dimensions.find(dim => d.isCopy ? dim.entityId === d.mainDimId : dim.entityId === d.entityId).attributes;
      let listOfAttributes;
      if (attributes.length > 0) {
        listOfAttributes = attributes.map(attr => attr.attributeDisplayName).join(', ');
        deleteConfirmModalText.push(`Attribute(s): ${listOfAttributes}`);
      }

      const links = this.data.links.filter(link => d.entityId === link.toEntityId);
      let listOfLinks;
      if (links.length > 0) {
        listOfLinks = links.map(link => link.alias ? link.alias : d.entityDisplayName).join(', ');
        deleteConfirmModalText.push(`Link(s): ${listOfLinks}`);
      }

      deleteConfirmModalText = deleteConfirmModalText.join(', ');
      deleteConfirmModalText = d.isCopy ? `Are you sure you want to delete ${d.entityDisplayName}? Following link: ${listOfLinks} will be deleted.` :
        `Are you sure you want to delete ${d.entityDisplayName}? ${deleteConfirmModalText ? `Following ${deleteConfirmModalText} will be deleted.` : ''}`;

      this.setConfirmModal({
        ...vm.confirmModalData,
        ...{
          show: true,
          title: 'Delete Dimension',
          text: deleteConfirmModalText,
          callback: async () => {
            let res;
            if (d.isCopy) {
              const shadowDims = this.originalData.links.filter(l => l.toEntityId === d.mainDimId && l.alias === d.entityDisplayName);
              for (const l of shadowDims) {
                res = await vm.onDeleteLink(l);
              }
            } else {
              res = await vm.deleteDimension(d.entityId);
            }
            if (res.success) {
              vm.$toasted.success('Dimension deleted successfully', {
                duration: TOASTER_DURATION,
              });
            } else {
              vm.$toasted.error(res.body.ErrorMessage, {
                duration: TOASTER_DURATION,
              });
            }
          },
        },
      });
    },
    deleteFactHelper(label, d) {
      const vm = this;
      let deleteConfirmModalText = [];

      const attributes = this.originalData.facts.find(fact => fact.entityId === d.entityId).attributes;
      let listOfAttributes;
      if (attributes.length > 0) {
        listOfAttributes = attributes.map(attr => attr.attributeDisplayName).join(', ');
        deleteConfirmModalText.push(`Attribute(s): ${listOfAttributes}`);
      }

      const links = this.data.links.filter(link => d.entityId === link.fromEntityId && link.linkId);
      let listOfLinks;
      if (links.length > 0) {
        listOfLinks = links.map(link => link.alias ? link.alias : this.data.dimensions.find(dim => dim.entityId === link.toEntityId).entityDisplayName).join(', ');
        deleteConfirmModalText.push(`Link(s): ${listOfLinks}`);
      }

      const mainDimIds = [];
      links.forEach(link => {
        const index = mainDimIds.findIndex(id => id === link.toEntityId);
        if (index === -1) {
          mainDimIds.push(link.toEntityId);
        }
      });
      let dimensions = [];
      let listOfDimensions;
      mainDimIds.forEach(id => {
        dimensions = [...dimensions, ...this.data.dimensions.filter(dim => dim.mainDimId === id && d.entityId === dim.fromEntityId)];
      });
      if (dimensions.length > 0) {
        listOfDimensions = dimensions.map(dim => dim.entityDisplayName).join(', ');
        deleteConfirmModalText.unshift(`Dimension(s): ${listOfDimensions}`);
      }

      deleteConfirmModalText = deleteConfirmModalText.join(', ');
      deleteConfirmModalText = `Are you sure you want to delete ${d.entityDisplayName}?
      ${deleteConfirmModalText ? `Following ${deleteConfirmModalText} will be delete.` : ''}`;

      this.setConfirmModal({
        ...vm.confirmModalData,
        ...{
          show: true,
          title: 'Delete Fact',
          text: deleteConfirmModalText,
          callback: async () => {
            const {success, body} = await vm.deleteFact(d.entityId);
            if (success) {
              vm.$toasted.success('Fact deleted successfully', {
                duration: TOASTER_DURATION,
              });
            } else {
              vm.$toasted.error(body.ErrorMessage, {
                duration: TOASTER_DURATION,
              });
            }
          },
        },
      });
    },
    deleteMeasureHelper(label, d) {
      const vm = this;
      const list = this.originalData.facts.find(elem => elem.uuid === d.uuid);
      if (!list) {
        return;
      }

      this.setRemoveItemsModal({
        show: true,
        title: 'Remove Measure',
        items: list.measures,
        fields: ['minorElement', 'name'],
        callback: (item) => {
          vm.setConfirmModal({
            ...vm.confirmModalData,
            ...{
              show: true,
              title: 'Delete Measure',
              text: `Are you sure you want to delete ${item.name}?`,
              callback: () => {
                vm.deleteMeasure({uuid: item.uuid});
                vm.deleteMeasureHelper(label, d);
              },
            },
          });
        },
      });
    },
    deleteLinkHelper(label, d) {
      // TODO for dimension
      const vm = this;

      const items = [];
      this.originalData.links.forEach(item => {
        if (item.fromEntityId === d.entityId) {
          const dimItem = this.originalData.dimensions.find(dim => dim.entityId === item.toEntityId);
          items.push({
            ...dimItem,
            linkId: item.linkId,
            alias: item.alias ? item.alias : dimItem.entityDisplayName,
          });
        }
      });

      this.setRemoveItemsModal({
        show: true,
        title: 'Remove Link',
        items: items,
        loading: false,
        fields: [{key: 'alias', label: 'Dimension'}],
        callback: (item) => {
          vm.setConfirmModal({
            ...vm.confirmModalData,
            ...{
              show: true,
              title: 'Delete Link',
              text: `Are you sure you want to delete link${item.length && item.length > 1 ? 's' : ''} with
              ${item.length ? item.map(l => l.alias ? l.alias : l.entityDisplayName).join(', ').replace(/, ([^,]*)$/, ' and $1') : item.entityDisplayName}?`,
              callback: async () => {
                if (item.length) {
                  for (const link of item) {
                    await vm.onDeleteLink(link);
                  }
                } else {
                  await vm.onDeleteLink(item);
                }
                vm.deleteLinkHelper(label, d);
              },
            },
          });
        },
      });
    },
    modifyAttributesHelper(isEdit = false) {
      this.isAttrEdit = false;
      const vm = this;
      let items = [];
      let selectedFact;
      let attributes = [];

      if (this.node.type === 'dimension') {
        let id = this.node.entityId;
        if (this.node.isCopy) {
          id = this.node.mainDimId;
        }
        selectedFact = this.originalData.dimensions.find(d => d.entityId === id);
      } else {
        selectedFact = this.originalData.facts.find(fact => fact.entityId === this.node.entityId);
      }
      attributes = selectedFact.attributes;


      if (attributes.length > 0) {
        items = [...attributes];
      }
      this.setRemoveItemsModal({
        show: true,
        title: isEdit ? 'Edit Attributes' : 'Remove Attributes',
        isEdit: isEdit,
        items: items,
        loading: false,
        fields: [{key: 'attributeDisplayName', label: 'Attributes'}],
        callback: (item) => {
          if (isEdit) {
            vm.showAttributesModal({entityId: item.entityId, data: item});
            this.isAttrEdit = true;
          } else {
            vm.setConfirmModal({
              ...vm.confirmModalData,
              ...{
                show: true,
                title: 'Delete Attribute',
                text: `Are you sure you want to delete ${item.length ? item.length : item.attributeDisplayName} attribute${item.length && item.length > 1 ? 's' : ''}?`,
                callback: async () => {
                  if (item.length) {
                    for (const attr of item) {
                      await vm.onDeleteAttribute(attr);
                    }
                  } else {
                    await vm.onDeleteAttribute(item);
                  }
                  vm.modifyAttributesHelper();
                },
              },
            });
          }
        },
      });
    },
    isDoNotAggregate(type) {
      return type === 'DoNotAggregate';
    },
    resetView() {
      this.$emit('resetView');
    },
  },
};
</script>

<style lang="scss">
#contextMenu {
  /deep/ .lobi-spinner {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: white;
    z-index: 1;
  }

  .expand-button {
    display: block;
    margin: 0 auto;
  }

  ul li {
    cursor: pointer;
  }


}
</style>
